"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Imports
require("./index.scss");
var app_component_1 = require("./app/app.component");
// Run app
app_component_1.App.run();
